import PurchaseOrderImport from "../components/PurchaseOrderImport";

const PurchaseOrderImportPage = () => {
  return <PurchaseOrderImport />;
};

export default PurchaseOrderImportPage;
